import React from "react";
import PropTypes from "prop-types";

const SMSIcon = ({active, ...rest}) => {
    const colour = active ? "#3D8BDA" : "#7C7C7C";
    return (
        <svg width={91} height={91} viewBox="0 0 91 91" {...rest}>
            <g fill="none" fillRule="evenodd">
                <rect fill={colour} width={91} height={91} rx={19} data-test-id="rect" />
                <path
                    d="M35.097 69.273C30.71 71.284 27.575 72.527 25.69 73c-6.63 1.666-10.306.845-8-1 3.093-2.474 5.325-5.522 6.696-9.144C19.197 57.99 16 51.336 16 44c0-14.912 13.208-27 29.5-27S75 29.088 75 44 61.792 71 45.5 71c-3.662 0-7.168-.61-10.403-1.727z"
                    fill="#FFF"
                />
                <text
                    fontFamily="Nunito"
                    fontSize={22}
                    fontWeight="bold"
                    fill={colour}
                    data-test-id="text"
                >
                    <tspan x={23} y={51}>
                        {"SMS"}
                    </tspan>
                </text>
            </g>
        </svg>
    );
};
SMSIcon.propTypes = {
    active: PropTypes.bool,
};

SMSIcon.defaultProps = {
    active: false,
};

export default SMSIcon;
